import $ from 'jquery'

export default class Faq {
  constructor() {
    this.elm = document.querySelector('html')
  }

  init() {
    this.faqAccordion()
  }

  faqAccordion() {
    $('.c-faqPicList__item').each((index, elAcc) => {
      const $this = $(elAcc)

      const $btnAccd = $this.find('.c-faqPicList__question')

      $btnAccd.on('click', e => {
        const $thisAcc = $(e.currentTarget)

        $thisAcc.next('.c-faqPicList__answer').stop().slideToggle()
      })

      // resize
      $(window).on('breakpointChange', () => {
        $('.c-faqPicList__answer').removeAttr('style')
      })
    })
  }
}
